import Wrapper from "zyp-kiosk";
import {useSelector, useDispatch} from "react-redux";
import {AppState} from "../store";
import {USER_TYPE, USER_TYPE_ENUM} from "../utils/mapped-data";
import { useEffect, useState } from "react";
import {useCookies} from "react-cookie";
import {refreshingToken} from "../store/actions";


export default function Kiosks() {
    const dispatch = useDispatch();
    const {
        common: { userType , token},
    } = useSelector<AppState, AppState>((state) => state);

    const [loading, setLoading] = useState(true); // Loading state
    const [currentToken, setCurrentToken] = useState<string | null>(null);
    const [cookies] = useCookies();
    console.log("token cookie : ", cookies?.meta?.token?.refreshToken)
    useEffect(() => {
        dispatch(refreshingToken(cookies?.meta?.token?.refreshToken, function (currentToken){
            console.log("currentToken : ", currentToken)
            setCurrentToken(currentToken)
            setLoading(false);
        }))
    }, [token]);

    if (loading) {
        return <div>Loading...</div>; // Show loading UI
    }

    console.log("token: ", currentToken);
    console.log("reached in kiosk prod tab....");
    return (
        <Wrapper
            login= {false}
            token={currentToken} env="prod"  role={
            userType !== undefined
                ? (USER_TYPE_ENUM[userType] === "Fleet Owner Admin" ? "CLIENT_ADMIN" : USER_TYPE_ENUM[userType]?.toUpperCase())
                : ''
        }
        />
    );
}